const colorOption = ['#178FFF', '#30DAD7', '#FF7045', '#FFCD45', '#FF9F45', '#7AE778', '#4D17FF'];

const gridOption = {
  top: 30,
  right: 20,
  bottom: 30,
};

const tooltipOption = {
  backgroundColor: 'white',
  padding: 12,
  textStyle: {
    color: 'rgba(0,0,0,.65)',
  },
  extraCssText: 'box-shadow: 0 4px 12px 0 rgba(0,0,0,.1);',
};

const xAxisOption = {
  type: 'category',
  axisTick: {
    alignWithLabel: true,
    lineStyle: {
      color: '#BFBFBF',
    },
  },
  axisLine: {
    lineStyle: {
      color: '#BFBFBF',
    },
  },
  axisLabel: {
    color: 'rgba(0,0,0,.65)',
    fontSize: 12,
    lineHeight: 17,
  },
};

const yAxisOption = {
  type: 'value',
  axisLine: {
    show: false,
  },
  axisTick: {
    show: false,
  },
  axisLabel: {
    margin: 4,
    color: 'rgba(0,0,0,.65)',
    fontSize: 12,
    lineHeight: 17,
  },
  splitLine: {
    lineStyle: {
      color: '#E9E9E9',
      type: 'dashed',
    },
  },
};

export function setUserBindChartOption(data, type, name) {
  let bizData;
  if (type === 'IncreaseQuantity') {
    bizData = data.map(item => item.increaseQuantity);
  } else if (type === 'DecreaseQuantity') {
    bizData = data.map(item => item.decreaseQuantity);
  } else if (type === 'RealIncreaseQuantity') {
    bizData = data.map(item => item.realIncreaseQuantity);
  } else {
    bizData = data.map(item => item.totalQuantity);
  }
  return {
    color: colorOption,
    tooltip: {
      ...tooltipOption,
      trigger: 'axis',
      formatter: `{b}<br/>${name}: {c}`,
    },
    grid: {
      ...gridOption,
      left: 50,
    },
    xAxis: {
      ...xAxisOption,
      data: data.map(item => item.statisticsDate),
      axisPointer: {
        lineStyle: {
          color: 'rgba(0,0,0,0.1)',
        },
      },
    },
    yAxis: {
      ...yAxisOption,
      minInterval: 1,
    },
    series: [
      {
        data: bizData,
        type: 'line',
        areaStyle: {
          color: {
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(23,143,255,.25)',
              },
              {
                offset: 1,
                color: 'rgba(255,255,255,.4)',
              },
            ],
          },
        },
        smooth: false,
        showSymbol: false,
      },
    ],
  };
}

export function f() {
  console.log('');
}
